import calculateAge from "./calculateAge";

export function formValidation(values: any) {
    const errors: any = {};

    [
        'username',
        'email',
        'fullName',
        'dateOfBirth',
        'zipCode',
        'password',
        'confirmPassword'
    ].forEach((name) => {
        if (!values[name] || values[name].length < 1) {
            errors[name] = `${name.replace(/([A-Z])/, ' $1').toLowerCase()} required`;
        }
    });

    if (values.zipCode.length < 5) {
        errors.zipCode = 'Zip code must be at least 5 characters long';
    }

    if (values.zipCode.length > 10) {
        errors.zipCode = 'Zip code must be less than 10 characters long';
    }

    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        errors.email = 'Invalid email address';
    }

    if (values.username.length < 3) {
        errors.username = 'Username must be at least 3 characters long';
    }

    if (values.username.length > 40) {
        errors.username = 'Username must be less than 40 characters long';
    }

    if (!/^[a-zA-Z0-9-.]*$/.test(values.username)) {
        errors.username = 'Invalid username, only use alphanumeric, - and .';
    }

    const passwordMinLength = 9;

    if (values?.password?.length < passwordMinLength) {
        errors.password = `Passwords must be ${passwordMinLength} characters long`;
    }

    if (values?.password !== values?.confirmPassword) {
        errors.confirmPassword = 'Passwords do not match';
    }

    if (values?.dateOfBirth) {
        const dateOfBirth = new Date(values.dateOfBirth);

        if (dateOfBirth.toString() === 'Invalid Date') {
            errors.dateOfBirth = 'Invalid date';
        }
    }

    const age = calculateAge(values.dateOfBirth);

    if (age < 18) {
        errors.dateOfBirth = 'You must be at least 21 years old, or 18+ with a medical card to use this service';
    }

    return errors;
}